import React, { useEffect, useState } from "react";
import styles from "./home.module.css";
import {
  Button,
  ButtonGroup,
  Divider,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import Loader from "./Loader";

const Home = () => {
  const [book, setbook] = useState("bukhari");
  const [hadith, sethadith] = useState();

  const [loading, setloading] = useState(false);

  const generateRandom = () => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    if (book !== undefined) {
      setloading(true);
      fetch(
        `https://random-hadith-generator.vercel.app/${book}/`,
        requestOptions
      )
        .then((response) => {
          if (!response.ok) {
            setloading(false);
            console.log("Error in getting the data");
          }
          return response.json();
        })
        .then((data) => {
          setloading(false);
          sethadith(data?.data);
        })
        .catch((error) => {
          setloading(false);
          console.log("Error while fetching data:", error);
        });
    }
  };

  useEffect(() => {
    generateRandom();
  }, []);

  const [customBook, setCustomBook] = useState("");
  const [hadithNumber, setHadithNumber] = useState("");
  const [loadingcustom, setloadingcustom] = useState(false);
  const generateCustom = () => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    if (customBook !== "" && hadithNumber !== "") {
      setloadingcustom(true);
      fetch(
        `https://random-hadith-generator.vercel.app/${customBook}/${hadithNumber}`,
        requestOptions
      )
        .then((response) => {
          if (!response.ok) {
            setloadingcustom(false);
            console.log("Error in getting the data");
          }
          return response.json();
        })
        .then((data) => {
          setloadingcustom(false);
          sethadith(data?.data);
          setCustomBook("");
          setHadithNumber("");
        })
        .catch((error) => {
          setloadingcustom(false);
          console.log("Error while fetching data:", error);
        });
    }
  };

  return (
    <div className={styles.home}>
      <div className={styles.container}>
        <p className={styles.heading}>بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيم</p>
        {hadith !== undefined && (
          <div className={styles.hadith_container}>
            <p>Book: {hadith && hadith?.book}</p>
            <Divider />
            <p>Book Name: {hadith && hadith?.bookName}</p>

            <Divider />
            <p>{hadith && hadith?.chapterName}</p>
            <Divider />
            <p>{hadith && hadith?.header}</p>
            <p>{hadith && hadith?.hadith_english}</p>
            <p style={{ textAlign: "end" }}>{hadith && hadith?.refno}</p>
          </div>
        )}
      </div>
      <div className={styles.buttons}>
        <div className={styles.subBTN}>
          <p>Get Random Hadith From</p>
          <div className={styles.customRANDOM}>
            <TextField
              select
              label="Select Hadith Book"
              fullWidth
              size="small"
              value={book}
              onChange={(e) => setbook(e.target.value)}
            >
              <MenuItem value="bukhari">Bukhari</MenuItem>
              <MenuItem value="muslim">Muslim</MenuItem>
              <MenuItem value="abudawud">Abu Dawud</MenuItem>
              <MenuItem value="ibnmajah">Ibn-Majah</MenuItem>
              <MenuItem value="tirmidhi">Al-Tirmidhi</MenuItem>
            </TextField>
            <Button size="small" variant="contained" onClick={generateRandom}>
              {loading ? (
                <>
                  Getting Hadith{" "}
                  <div className={styles.loader}>
                    <Loader color="white" />
                  </div>
                </>
              ) : (
                "Get Hadith"
              )}
            </Button>
          </div>
        </div>
        <Divider className={styles.divider} />
        <div className={styles.subBTN} style={{ width: "400px" }}>
          <p style={{ textAlign: "center" }}>Get Custom Hadith From</p>
          <div className={styles.customRANDOM}>
            <div className={styles.custom}>
              <TextField
                select
                label="Select Hadith Book"
                fullWidth
                size="small"
                value={customBook}
                onChange={(e) => setCustomBook(e.target.value)}
              >
                <MenuItem value="bukhari">Bukhari (limit 1-7563)</MenuItem>
                <MenuItem value="muslim">Muslim (limit 1-3032)</MenuItem>
                <MenuItem value="abudawud">Abu Dawud (limit 1-3998)</MenuItem>
                <MenuItem value="ibnmajah">Ibn Majah (limit 1-4342)</MenuItem>
                <MenuItem value="tirmidhi">Al-Tirmidhi (limit 1-3956)</MenuItem>
              </TextField>
              <TextField
                size="small"
                label="Enter Hadith Number"
                variant="outlined"
                type="number"
                value={hadithNumber}
                onChange={(e) => setHadithNumber(e.target.value)}
                fullWidth
              />
            </div>
            <Button
              className={styles.lastBtn}
              size="small"
              variant="contained"
              onClick={generateCustom}
            >
              {loadingcustom ? (
                <>
                  Getting Hadith{" "}
                  <div className={styles.loader}>
                    <Loader color="white" />
                  </div>
                </>
              ) : (
                "Get Hadith"
              )}
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.me}>
        <p>Developed By</p>
        <a href="https://muazimmaqbool.vercel.app/" target="_blank">
          Muazim Maqbool
        </a>
      </div>
    </div>
  );
};

export default Home;
